/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMercury = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor" fillRule="evenodd">
      <path d="M13 15v7h-2v-7z" />
      <path d="M16 18v2H8v-2zM12 6a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
      <path d="M6.969 1.753c.606 2.378 2.64 4.13 4.813 4.241L12 6v2C8.885 8 6.027 5.688 5.1 2.5l-.069-.253zm10.062 0 1.938.494c-.824 3.233-3.624 5.628-6.724 5.748L12 8V6c2.181 0 4.266-1.676 4.966-4.011z" />
    </g>
  </Icon>
);
export { SvgMercury as Mercury };
